import * as actions from 'client/actions/entityActions'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { useCallback } from 'react'
import { Dispatch } from 'redux'

export const useRemoveEntityMobileStyle = (
  dispatch: Dispatch<any>,
  entity: OldEntityInterface,
) => {
  return useCallback(
    (style: OldEntityInterface['styles']) => () => {
      const updatedEntity = {
        ...entity,
        mobileStyles: {
          ...entity.mobileStyles,
        },
      }

      delete updatedEntity.mobileStyles[style]
      dispatch(actions.update(updatedEntity))
    },
    [entity],
  )
}
